import { IShadows, ISingleTheme } from "../types";

export const hexToRGBA = (hex: string, alpha: number = 1): string => {
    let r: number;
    let g: number;
    let b: number;

    if (hex.length === 4) {
        const tempR = hex.slice(1, 2);
        const tempG = hex.slice(2, 3);
        const tempB = hex.slice(3, 4);

        r = parseInt(tempR + tempR, 16);
        g = parseInt(tempG + tempG, 16);
        b = parseInt(tempB + tempB, 16);
    } else {
        r = parseInt(hex.slice(1, 3), 16);
        g = parseInt(hex.slice(3, 5), 16);
        b = parseInt(hex.slice(5, 7), 16);
    }

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const emToRem = (sizeValue: string): string => sizeValue.replace("em", "rem");

export const truncateNumbers = (value: string | number, fractionDigits: number = 3): number =>
    parseFloat((+value).toFixed(fractionDigits));

export const emToPx = (
    value: string | number,
    option: { baseValue?: number; fractionDigits?: number } = {}
): number => {
    const { baseValue = 16, fractionDigits = 3 } = option;
    return truncateNumbers(+value * baseValue, fractionDigits);
};

export const getShadow = (theme: ISingleTheme, shadow: keyof IShadows): string => {
    const shadowPropsArray = theme.shadows[shadow];
    const shadowStrings: string[] = [];

    shadowPropsArray.forEach(shadowProps => {
        shadowStrings.push(
            `${shadowProps.x}px ${shadowProps.y}px ${shadowProps.blur}px ${shadowProps.spread}px ${shadowProps.color}`
        );
    });

    return `${shadowStrings.join(", ")};`;
};
